import {createGlobalSlice} from "@/data/create_global_slice.js";

export const {reducer, replace, update} = createGlobalSlice("Role");
